import { useState } from 'react';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { RiAddFill } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import useGetPortfolioList from '@hooks/useGetPortfolioList';
import usePaginationParams from '@hooks/usePaginationParams';

import AddDialog from './components/AddDialog';
import PortfolioCard from './components/PortfolioCard';

const Portfolio = () => {
  const [showAddDialog, setShowAddDialog] = useState(false);

  const { checkIfHasRole } = useAuthContext();
  
  const {
    getPortfolios,
    portfolios,
    totalPages,
    loading,
  } = useGetPortfolioList();

  usePaginationParams({ onParamsChange: getPortfolios });

  const getCurrentComponent = () => {
    if (loading) return <Loading />;
    
    if (portfolios.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum portfólio encontrado.
        </Box>
      );
    }

    return (
      <PaginationRouterContainer
        total={totalPages}
        onPaginationChange={getPortfolios}
      >
        {portfolios.map((portfolio) => (
          <PortfolioCard
            key={portfolio.id}
            portfolio={portfolio}
            refetch={() => getPortfolios({})}
          />
        ))}
      </PaginationRouterContainer>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Heading>Portfólios</Heading>
        {checkIfHasRole('CAN_CREATE_PORTFOLIO') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Novo
          </Button>
        )}
      </Flex>

      {getCurrentComponent()}

      {showAddDialog && (
        <AddDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getPortfolios({})}
        />
      )}
    </Box>
  );
};

export default Portfolio;
